import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faSyringe, 
  faBone, 
  faXRay, 
  faHeartbeat,
  faStethoscope,
  faFlask
} from "@fortawesome/free-solid-svg-icons";

const servicios = [
  {
    icon: faStethoscope,
    title: "Cirugías Generales",
    description: "Procedimientos quirúrgicos y esterilizaciones con equipos modernos",
    color: "var(--primary)"
  },
  {
    icon: faBone,
    title: "Traumatología",
    description: "Cirugías traumatológicas especializadas para fracturas y lesiones",
    color: "var(--accent)"
  },
  {
    icon: faXRay,
    title: "Radiografía Digital",
    description: "Diagnóstico por imagen de alta resolución en tiempo real",
    color: "var(--primary)"
  },
  {
    icon: faHeartbeat,
    title: "Ecografías",
    description: "Ultrasonido para diagnóstico de órganos internos",
    color: "var(--accent)"
  },
  {
    icon: faSyringe,
    title: "Vacunas",
    description: "Plan de vacunación y desparasitación según la edad de tu mascota",
    color: "var(--primary)"
  },
  {
    icon: faFlask,
    title: "Laboratorio",
    description: "Hemogramas, perfiles bioquímicos y análisis hematológicos",
    color: "var(--accent)"
  }
];

function Servicios() {
  return (
    <section className="py-5" id="section_servicios" style={{ backgroundColor: 'var(--background-alt)' }}>
      <div className="container px-5 my-5">
        {/* Section Header */}
        <div className="row mb-5">
          <div className="col-lg-6 mx-auto text-center animate-fade-in-up">
            <span className="text-uppercase fw-bold text-primary-color" style={{ letterSpacing: '2px', fontSize: '0.875rem' }}>
              Lo que hacemos
            </span>
            <h2 className="section-title mt-2">
              Servicios Destacados
            </h2>
            <p className="section-subtitle mx-auto">
              Contamos con equipamiento moderno y profesionales con más de 30 años de experiencia
            </p>
          </div>
        </div>
        
        {/* Services Grid */}
        <div className="row g-4">
          {servicios.map((servicio, index) => (
            <div key={index} className="col-md-6 col-lg-4">
              <div 
                className="glass-card h-100 animate-fade-in-up"
                style={{ animationDelay: `${(index + 1) * 100}ms` }}
              >
                {/* Icon */}
                <div 
                  className="rounded-3 d-inline-flex align-items-center justify-content-center mb-3"
                  style={{ 
                    width: '60px', 
                    height: '60px', 
                    background: servicio.color === 'var(--primary)' 
                      ? 'var(--primary-gradient)' 
                      : 'linear-gradient(135deg, var(--accent) 0%, var(--accent-light) 100%)',
                    color: 'white'
                  }}
                >
                  <FontAwesomeIcon icon={servicio.icon} size="xl" />
                </div>
                
                {/* Content */}
                <h5 className="mb-2" style={{ fontFamily: 'var(--font-heading)', fontWeight: 600 }}>
                  {servicio.title}
                </h5>
                <p className="mb-0" style={{ color: 'var(--text-secondary)', fontSize: '0.95rem' }}>
                  {servicio.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Servicios;